module.exports = __webpack_public_path__ + "static/debraDavis-761ebddd7129ac57cdb8e46c9d56b70b.webp";